import React from "react";
import { Button } from "@ui/button";
import { AlertTriangle } from "lucide-react";
import { RegistrationResult } from "./register_data";

interface Props {
  result: RegistrationResult | null;
  onRetry: () => void;
}

export default function RegistrationBanner({ result, onRetry }: Props) {
  if (!result) return null;
  const { success, tableName, rowCount, columnCount, error } = result;

  return (
    <div
      className={`p-4 rounded-md ${
        success ? "bg-green-50 border border-green-200" : "bg-red-50 border border-red-200"
      }`}
    >
      <div className="flex items-center gap-2">
        {success ? (
          <div className="h-5 w-5 rounded-full bg-green-500 flex items-center justify-center text-white">
            ✓
          </div>
        ) : (
          <AlertTriangle className="h-5 w-5 text-red-600" />
        )}
        <h3 className={`font-medium ${success ? "text-green-800" : "text-red-800"}`}>
          {success ? "Registration Successful" : "Registration Failed"}
        </h3>
      </div>

      {success ? (
        <div className="mt-2 grid grid-cols-2 gap-2 text-sm">
          <div>
            <p className="text-muted-foreground">Table Name</p>
            <p className="font-medium">{tableName}</p>
          </div>
          <div>
            <p className="text-muted-foreground">Row Count</p>
            <p className="font-medium">{rowCount.toLocaleString()}</p>
          </div>
          <div>
            <p className="text-muted-foreground">Column Count</p>
            <p className="font-medium">{columnCount}</p>
          </div>
        </div>
      ) : (
        <div className="mt-3 space-y-2">
          <p className="text-sm text-red-600">{error}</p>
          <Button variant="outline" size="sm" onClick={onRetry}>
            Retry
          </Button>
        </div>
      )}
    </div>
  );
}
